import { Link } from '@tanstack/react-router';
import type { ActivityDetail } from '@painpal/contracts';
import { formatDuration } from '../../lib/format';
import { CountUp } from '../../ui/CountUp';
import { detailLayout, zonesNote, zonesTitle } from './runDetailModel';
import { missingZonesReason, zoneGroups, type ZoneGroup } from './zonesModel';
import styles from './analysis.module.css';

function ZoneGroupView({ group }: { group: ZoneGroup }) {
  return (
    <div className={styles.zoneGroup} role="group" aria-label={`${group.title} zones`}>
      <div className={styles.zoneHead}>
        <span className={styles.zoneTitle}>{group.title}</span>
        <span className={styles.zoneThreshold}>{group.threshold}</span>
      </div>
      <ul className={styles.zoneList}>
        {group.rows.map((row) => (
          <li key={row.key} className={styles.zoneRow}>
            <span className={styles.zoneName}>{row.name}</span>
            <span className={styles.zoneRange}>{row.range}</span>
            <span className={styles.zoneTrack} aria-hidden="true">
              <span className={styles.zoneBar} style={{ width: `${row.widthPct}%`, background: row.color }} />
            </span>
            <span className={styles.zoneTime}><CountUp value={row.seconds} format={formatDuration} /></span>
            <span className={styles.zonePct}>{`${row.pct}%`}</span>
          </li>
        ))}
      </ul>
      <span className={styles.zoneTotal}>{`TOTAL ${group.total}`}</span>
    </div>
  );
}

export function ZonesCard({ activity }: { activity: ActivityDetail }) {
  const groups = zoneGroups(activity.zones, activity.sport);
  const note = zonesNote(activity);
  return (
    <section className={styles.card} aria-labelledby="zones-title">
      <h2 id="zones-title" className={styles.cardTitle}>{zonesTitle(detailLayout(activity))}</h2>
      {groups.length === 0 ? (
        <p className={styles.zonesEmpty}>
          {missingZonesReason(activity)} · <Link to="/settings">SET THRESHOLDS →</Link>
        </p>
      ) : groups.map((group) => <ZoneGroupView key={group.key} group={group} />)}
      {groups.length > 0 && note !== null && <p className={styles.zonesNote}>{note}</p>}
    </section>
  );
}
